var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('Button',{attrs:{"expanded":"","disabled":!_vm.enabled,"outlined":_vm.outlined},on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }